import React, { useState, useEffect, useRef } from 'react';
import 'react-table-v6/react-table.css';
import { Col, Container, FormControl, Row, Table } from 'react-bootstrap';
import {
  Link,
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
// import { useEffect } from 'react';
import Loader from '../../../common/Loader';
import delivaApiService from '../../../../common/services/apiService';
import Header from '../../commonAdmin/Header';
import Sidebar from '../../commonAdmin/Sidebar';
import moment from 'moment';

const PromoUsage = (props) => {
  // hooks
  const history = useHistory();

  // states
  const [loading, setLoading] = useState(false);
  const [promo, setPromo] = useState(null);
  const [promoUsage, setPromoUsage] = useState(null);

  const [showLoader, setShowLoader] = useState(false);

  const [pageno, setPageno] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [pageArray, setPageArray] = useState([]);
  const [records, setRecords] = useState(10);
  const [totalRecords, setTotalRecords] = useState('');

  const [searchText, setSearchText] = useState('');
  // Triggered on input change
  const getSearchData = (e) => {
    const value = e.target.value;
    const trimmedValue = value.replace(/\s+/g, ' ').trim();
    setSearchText(trimmedValue);

    if (value.length === 0) {
      PromoUsageList(id, ''); // Show all on clear
    }
    // Do nothing if only spaces
  };

  const handleSearch = () => {
    const trimmedText = searchText.trim();
    if (trimmedText.length < 2) {
      return;
    }
    PromoUsageList(id, trimmedText); // Search only if 2+ chars
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // Fetch id from URL
  const { id } = useParams();

  // Prepare pagination array as per available records
  const generatePageArray = (totalPages, currentPage) => {
    let startPage, endPage;
    switch (true) {
      case totalPages <= 5:
        startPage = 1;
        endPage = totalPages;
        break;

      case currentPage <= 3:
        startPage = 1;
        endPage = 5;
        break;

      case currentPage + 1 >= totalPages:
        startPage = totalPages - 4;
        endPage = totalPages;
        break;

      default:
        startPage = currentPage - 2;
        endPage = currentPage + 2;
        break;
    }
    const pageArray = [];
    for (let i = startPage; i <= endPage; i++) {
      pageArray.push(i);
    }
    return pageArray;
  };

  // Manage switch pages through Pagination
  const onChangePage = (page) => {
    setPageno(page);
    setPageArray(generatePageArray(totalPage, page));
  };

  // Set No. of records per page
  const onChangeItemPerPage = (e) => {
    const rawValue = e.target.value;
    if (rawValue === '') {
      setRecords('');
      return;
    }
    if (rawValue === '0') {
      return;
    }
    const numberRegex = /^[1-9][0-9]*$/;
    if (numberRegex.test(rawValue)) {
      setRecords(rawValue);
      setPageno(1);
    }
  };

  // API :: Referal Data
  const getPromoDetails = (id) => {
    setLoading(true);
    delivaApiService('getPromo', { promoId: id })
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.status === 200) {
          const result = response?.data?.resourceData;
          setPromo(result);
          console.log('usage referral details', result);
          setLoading(false);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.error('Failed to update status:', error);
      });
  };

  // API :: Promo Usage List Data
  const PromoUsageList = async (id, searchValue = '') => {
    try {
      setLoading(true);
      const payload = {
        promoId: id,
        page: '',
        size: '',
        search: searchValue ? searchText : searchValue,
      };
      const [promoUsageList] = await Promise.all([
        delivaApiService('getUserListByPromoId', payload),
      ]);
      if (promoUsageList?.status === 200) {
        let data = promoUsageList.data?.resourceData;
        setPromoUsage(data);
        const totalRecords = promoUsageList.data?.totalRecords;
        const totalPages = Math.ceil(totalRecords / records);
        setTotalPage(totalPages);
        setPageArray(generatePageArray(totalPages, pageno));
        setLoading(false);
        setTotalRecords(totalRecords);
      }
    } catch (error) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    {
      if (id) {
        getPromoDetails(id);
        PromoUsageList(id);
      }
    }
  }, [id]);
  const convertToLocalDate = (dateString) => {
    if (!dateString) return '--';
    return moment.utc(dateString).local().format('DD MMM YYYY');
  };

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <section className="page-header mb-4">
                  <div className="w-100">
                    <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                      No. of Usage
                    </h3>
                    <h5 className="font-weight-normal mb-0 line-ht color-head">
                      <span
                        className="pointer"
                        onClick={() =>
                          history.push({
                            pathname: `/promotionReferralList`,
                            state: {
                              tab: 'promotion',
                            },
                          })
                        }
                      >
                        Promotion & Referral
                      </span>
                      <span className="icon-next mx-2 fs12"></span>
                      <span className="pointer">No. of Usage </span>
                    </h5>
                  </div>
                  <div className="page-search d-flex justify-content-between justify-content-lg-end gap-3 w-100">
                    <div className="position-relative">
                      <FormControl
                        type="text"
                        value={searchText}
                        placeholder={`Search ${
                          promo?.userType === 'delivery_agent'
                            ? 'Delivery Partner Name'
                            : 'Sender Name'
                        }`}
                        className="searchTxt mb-3 mb-lg-0"
                        onChange={(e) => getSearchData(e)}
                        onKeyDown={(e) => handleKeyDown(e)}
                      />
                      <span
                        className="icon-search"
                        onClick={handleSearch}
                      ></span>
                    </div>
                  </div>
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <h5 className="px-4">Promo Details</h5>
                      <hr />
                    </Col>
                  </Row>
                  <Row className="px-4">
                    <Col md={6} lg={3} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        User Type
                      </h5>
                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.userType === 'delivery_agent'
                          ? 'Delivery Partner'
                          : 'Sender'}
                      </p>
                    </Col>
                    <Col md={6} lg={3} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        Offer Name
                      </h5>
                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.offerName ? promo?.offerName : '--'}
                      </p>
                    </Col>
                    {/* <Col md={6} lg={3} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        Promotion Condition
                      </h5>
                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.userCategory === 'EXISTING_ON_BOARDING'
                          ? 'Existing Onboarding'
                          : promo?.userCategory === 'NEW_ON_BOARDING'
                            ? 'New Onboarding'
                            : '--'}
                      </p>
                    </Col> */}
                    <Col md={6} lg={3} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        Discount Type
                      </h5>
                      {/* <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                        {promo?.discountType ? promo?.discountType : '--'}
                      </p> */}
                      <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                        {promo?.promoDiscountType === 'FREE_DELIVERY'
                          ? 'Free delivery'
                          : promo?.promoDiscountType === 'FIXED_AMOUNT'
                          ? 'Fixed Amount'
                          : promo?.promoDiscountType === 'PERCENTAGE_DISCOUNT'
                          ? 'Percentage discount '
                          : '--'}
                      </p>
                    </Col>
                    {promo?.userType !== 'delivery_agent' && (
                      <Col md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Discount Percentage
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {promo?.percentageDiscount
                            ? promo?.percentageDiscount
                            : 0}
                          %
                        </p>
                      </Col>
                    )}
                    {promo?.userType === 'delivery_agent' && (
                      <>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            {promo?.userType === 'delivery_agent'
                              ? 'Reward Amount'
                              : 'Max Amount of Discount(upto)'}
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            ₦
                            {promo?.maxDiscountAmount
                              ? promo?.maxDiscountAmount
                              : 0}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            No. of Delivery
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promo?.noOfDelivery ? promo?.noOfDelivery : 0}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Delivery Duration
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promo?.deliveryDuration
                              ? `${promo?.deliveryDuration} ${
                                  promo?.deliveryDurationUnit === 'WEEk'
                                    ? 'Week'
                                    : 'Days'
                                }`
                              : 0}
                          </p>
                        </Col>
                      </>
                    )}
                    {promo?.userType !== 'delivery_agent' && (
                      <Col md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Max Amount of Discount
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          ₦
                          {promo?.maxDiscountAmount
                            ? promo?.maxDiscountAmount
                            : '--'}
                        </p>
                      </Col>
                    )}

                    <Col md={6} lg={3} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18 text-capitalize">
                        Promo duration
                      </h5>

                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.promotionStartDate
                          ? convertToLocalDate(promo?.promotionStartDate)
                          : '--' - convertToLocalDate(promo?.promotionEndDate)
                          ? convertToLocalDate(promo?.promotionEndDate)
                          : '--'}
                      </p>
                    </Col>
                    <Col md={6} lg={3} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        Code
                      </h5>
                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.code ? promo?.code : '--'}
                      </p>
                    </Col>

                    <Col md={12} lg={12} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        Description
                      </h5>
                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.description ? promo?.description : '--'}
                      </p>
                    </Col>
                    <Col md={12} lg={12} className="mb-4">
                      <h5 className="font-weight-normal color-grey fs18">
                        No. of Usage
                      </h5>
                      <p className="fs18 font-weight-500 mb-0 gray-600">
                        {promo?.noOfUsage ? promo?.noOfUsage : '--'}
                      </p>
                    </Col>
                  </Row>
                </section>
                <section className="user-list mb-4">
                  <h3 className="font-weight-normal mb-3 line-ht fs-24 color-33 text-nowrap">
                    List of User{' '}
                    <span className="color-grey">({totalRecords})</span>
                  </h3>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>
                          {promo?.userType === 'delivery_agent'
                            ? 'Delivery Partner Name'
                            : 'Sender Name'}
                          {/* <Link className="icon-up-and-down color-light-grey" /> */}
                        </th>
                        <th>Email ID</th>
                        <th>Date of Use</th>
                        {promo?.userType !== 'delivery_agent' ? (
                          <th>Order ID</th>
                        ) : (
                          <th></th>
                        )}
                      </tr>
                    </thead>
                    <tbody className="ttl-order-table">
                      {promoUsage?.length > 0 ? (
                        promoUsage?.map((usage, index) => {
                          return (
                            <tr key={index}>
                              <td>{(pageno - 1) * records + index + 1}</td>
                              <td>{usage.name}</td>
                              <td>{usage.email}</td>
                              <td>{usage.date}</td>
                              {promo?.userType !== 'delivery_agent' ? (
                                <td>
                                  {usage?.orderId ? (
                                    <Link
                                      to={`/billing/orderDetails/${usage?.orderId}`}
                                      className="link"
                                    >{`#${usage?.orderId}`}</Link>
                                  ) : (
                                    '--'
                                  )}
                                </td>
                              ) : (
                                <td></td>
                              )}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {promoUsage?.length > 0 && (
                    <nav
                      aria-label="Page navigation "
                      className="position-relative"
                    >
                      <ul className="pagination pg-blue deliva-pagination justify-content-end">
                        <li className="page-item">
                          <button
                            className="page-link rotate-180 control-btn"
                            aria-label="Previous"
                            onClick={() => onChangePage(pageno - 1)}
                            disabled={pageno === 1}
                          >
                            <span className="icon-next"></span>
                            <span className="sr-only">Previous</span>
                          </button>
                        </li>

                        {pageArray.map((page, ind) => (
                          <li key={ind} className="page-item">
                            <a
                              className={`page-link ${
                                pageno === page ? 'active' : ''
                              }`}
                              onClick={() => onChangePage(page)}
                            >
                              {page}
                            </a>
                          </li>
                        ))}

                        <li className="page-item">
                          <button
                            className="page-link control-btn"
                            aria-label="Next"
                            onClick={() => onChangePage(pageno + 1)}
                            disabled={pageno === totalPage}
                          >
                            <span className="icon-next"></span>
                            <span className="sr-only">Next</span>
                          </button>
                        </li>

                        <li className="page-value">
                          Enter Per Page{' '}
                          <input
                            type="text"
                            placeholder="Records"
                            name="records"
                            value={records}
                            onChange={onChangeItemPerPage}
                          />
                        </li>
                      </ul>
                    </nav>
                  )}
                </section>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
      <Loader showLoader={loading} />
    </div>
  );
};
export default PromoUsage;
